import React, { ComponentProps, useCallback, useRef } from 'react';
import Form, { FormUtils } from '../../../components/molecules/Form';
import { RichtextTemplate } from '../partials/Richtext/RichtextTemplate';
import { InteractionStatus } from '../../../types/InteractionStatus';
import IForm from '../../../types/IForm';
import { asFetchableView } from '../../../_lib/ViewFetcher';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { useBlockContext, useRefreshBlockInDefaultView } from '../../../_lib/BlockFetcher';

type RichtextEditProps = {
  form: IForm;
};

function RichtextEdit({ form }: RichtextEditProps) {
  const { t } = useSonTranslation('Editor');
  const { t: tRichText } = useSonTranslation('RichText');
  const { refresh } = useRefreshBlockInDefaultView();
  const { uuid } = useBlockContext();
  const timeout = useRef<NodeJS.Timeout>(undefined);
  const statusMessages = {
    [InteractionStatus.SUCCESS]: FormUtils.createStatusMessage(t('status.success')),
    [InteractionStatus.SENDING]: FormUtils.createStatusMessage(t('status.sending')),
    [InteractionStatus.FAIL]: FormUtils.createStatusMessage(t('status.fail')),
  };

  const onSuccess = useCallback(() => {
    timeout.current = setTimeout(() => refresh(), 2000);
  }, [refresh]);

  const abortRefetch = () => {
    clearTimeout(timeout.current);
  };

  return (
    <Form id="rich-text-update-form" model={form} onSuccess={onSuccess}>
      <RichtextTemplate
        statusMessages={statusMessages}
        // This has to be a sensible changedetector cause this block can dissapear several times on one Page
        editorID={`editor-${uuid}`}
        saveButtonText={tRichText('saveButton')}
        abortRefetch={abortRefetch}
      />
    </Form>
  );
}

export const RichtextEditView = asFetchableView(RichtextEdit);
export type RichtextEditView = ComponentProps<typeof RichtextEditView>;
